var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import React, { Component } from 'react';
import { Icon, Modal, Snackbar } from '@cimpress/react-components';
import { connect } from 'react-redux';
import * as colors from '@cimpress/react-components/lib/colors';
import { customBulkExport, downloadSampleCSV } from '../../services/customBulkExport';
import '../../styles/fileupload.css';
import { toggleCustomUploadModal } from '../../actions/BulkExportAction';
import { ingestData } from '../../services/cimbaIngestion';
import 'react-dropzone-uploader/dist/styles.css';
import Dropzone from 'react-dropzone-uploader';

function mapStateToProps(state) {
  return {
    bulkExport: state.bulkExport,
    customBulkExport: state.customBulkExport,
    pricingGrid: state.pricingGrid
  };
}

var mapDispatchToProps = {
  toggleCustomUploadModal: toggleCustomUploadModal
};
var connector = connect(mapStateToProps, mapDispatchToProps);

var CustomUpload =
/** @class */
function (_super) {
  __extends(CustomUpload, _super);

  function CustomUpload() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      files: [],
      fileId: undefined,
      showJobStatus: false,
      jobStatus: undefined
    };

    _this.onCustomUploadSubmit = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var sku;

        var _this = this;

        return __generator(this, function (_a) {
          sku = this.props.customBulkExport.sku;
          this.props.toggleCustomUploadModal(false);
          ingestData({
            feature: 'CustomUpload'
          });
          return [2
          /*return*/
          , customBulkExport(sku, {}, this.state.fileId).then(function () {
            _this.setState({
              showJobStatus: true,
              jobStatus: 'success'
            });
          }).catch(function () {
            _this.setState({
              showJobStatus: true,
              jobStatus: 'danger'
            });
          })];
        });
      });
    };

    _this.downloadSampleCSV = function () {
      var sku = _this.props.customBulkExport.sku;
      return downloadSampleCSV(sku).catch(function () {
        _this.setState({
          showJobStatus: true,
          jobStatus: 'danger'
        }, function () {
          return setTimeout(function () {
            return _this.setState({
              showJobStatus: false,
              jobStatus: null
            });
          }, 3000);
        });
      });
    }; // specify upload params and url for your files


    _this.getUploadParams = function (_a) {
      var meta = _a.meta;
      var onGetAccessToken = _this.props.pricingGrid.onGetAccessToken;
      var accessToken = onGetAccessToken();
      return {
        url: 'https://startingpriceapi.financialflows.cimpress.io/v1/preferredCombinations/upload',
        headers: {
          Authorization: "Bearer " + accessToken
        }
      };
    }; // called every time a file's `status` changes


    _this.handleChangeStatus = function (_a, status) {
      var meta = _a.meta,
          file = _a.file,
          xhr = _a.xhr;

      if (status === 'done') {
        var response = JSON.parse(xhr.response);
        var fileId = response.id;

        _this.setState({
          files: [file],
          fileId: fileId
        });
      }
    };

    _this.toggleShowJobStatus = function () {
      _this.setState({
        showJobStatus: false,
        jobStatus: null,
        files: [],
        fileId: null
      });
    };

    return _this;
  }

  CustomUpload.prototype.componentWillUnmount = function () {
    this.setState({
      showJobStatus: false,
      jobStatus: null,
      files: [],
      fileId: null
    });
  };

  CustomUpload.prototype.render = function () {
    var _this = this;

    var showCustomUploadModal = this.props.bulkExport.showCustomUploadModal;
    var _a = this.state,
        showJobStatus = _a.showJobStatus,
        jobStatus = _a.jobStatus,
        files = _a.files;
    return React.createElement(React.Fragment, null, React.createElement(Modal, {
      className: "custom-modal-style upload-modal",
      show: showCustomUploadModal,
      onRequestHide: function onRequestHide() {
        return _this.props.toggleCustomUploadModal(false);
      },
      title: "Custom Upload",
      closeButton: true,
      footer: React.createElement("button", {
        type: "button",
        className: "btn btn-default",
        onClick: function onClick() {
          return _this.onCustomUploadSubmit();
        },
        disabled: !files || files && files.length === 0
      }, "Submit")
    }, React.createElement("div", {
      className: "container",
      style: {
        width: 'auto'
      }
    }, React.createElement("div", null, "Upload a file with the different product combinations to trigger a custom job wherein an email will be sent to you"), React.createElement("div", {
      className: "row download-sample-csv"
    }, React.createElement("span", {
      className: "sample-csv-text",
      onClick: function onClick() {
        return _this.downloadSampleCSV();
      }
    }, React.createElement(Icon, {
      color: colors.teal.base,
      name: "download-3-f"
    }), " ", React.createElement("a", null, "Download Sample"))), React.createElement("div", null, React.createElement(Dropzone, {
      getUploadParams: this.getUploadParams,
      onChangeStatus: this.handleChangeStatus,
      submitButtonContent: null,
      maxFiles: 1,
      inputWithFilesContent: "File Uploaded Successfully. Press submit",
      inputContent: null,
      multiple: false,
      accept: ".xls, .xlsx",
      maxSizeBytes: 20971520,
      styles: {
        dropzone: {
          minHeight: 60,
          maxHeight: 170,
          backgroundColor: '#f1f0ef'
        },
        input: {
          width: '300px',
          fontSize: '12px'
        },
        inputLabel: {
          color: '#656565',
          fontSize: '12px'
        },
        inputLabelWithFiles: {
          color: '#656565',
          fontSize: '12px'
        }
      }
    })))), React.createElement(Snackbar, {
      show: showJobStatus,
      bsStyle: jobStatus,
      delay: 3000,
      onHideSnackbar: this.toggleShowJobStatus
    }, jobStatus && jobStatus === 'success' && 'A custom job has been triggered. Once the job is complete, an email will be sent to you with the download link.' || jobStatus === 'danger' && 'An error occurred.'));
  };

  return CustomUpload;
}(Component);

export default connector(CustomUpload);